/**
 * Meta Pixel (Facebook Pixel) tracking utilities
 * Provides helper functions to fire custom lead events
 */

/**
 * Fire a custom lead event to Meta Pixel
 * @param {string} eventName - The name of the custom event (e.g., 'Apartment_search_lead')
 * @param {object} eventData - Optional event parameters/data
 */
export const trackLeadEvent = (eventName, eventData = {}) => {
  if (typeof window === "undefined" || !window.fbq) {
    console.warn("Meta Pixel (fbq) not available");
    return;
  }

  try {
    window.fbq("trackCustom", eventName, eventData);
  } catch (error) {
    console.error("Error tracking Meta Pixel event:", error);
  }
};

/**
 * Determine which lead event to fire based on user's answers
 * @param {object} answers - The welcome flow answers object
 * @returns {string|null} - The event name to fire, or null if no match
 */
export const getLeadEventName = (answers) => {
  if (!answers) return null;

  const persona = answers?.persona;
  const renterReasons = answers?.renterReasons || [];

  // Apartment_search_lead: renter looking to find a home
  if (persona === "renter" && renterReasons.includes("find-home")) {
    return "Apartment_search_lead";
  }

  // Moving_soon_lead: renter moving soon
  if (persona === "renter" && renterReasons.includes("moving-soon")) {
    return "Moving_soon_lead";
  }

  // Wants_Cash_Back_lead: renter wants cash back
  if (persona === "renter" && renterReasons.includes("cashback")) {
    return "Wants_Cash_Back_lead";
  }

  // Licensed_Agent_lead: licensed agent
  if (persona === "agent") {
    return "Licensed_Agent_lead";
  }

  // Owner_Operator_lead: owner/operator
  if (persona === "owner" || persona === "mom_and_pop" || persona === "large_owner") {
    return "Owner_Operator_lead";
  }

  // Learn_More_Lead: just learning
  if (persona === "just_learn") {
    return "Learn_More_Lead";
  }

  return null;
};

